import { Colors } from '../../consts/Colors';
export default class Card1 extends Phaser.GameObjects.Container {
    constructor(scene, x, y, cardData, deck) {
        super(scene, x, y, []);

        scene.add.existing(this);
        this.initPosition = { x: x, y: y }
        this.scene = scene;
        this.isDone = false;
        this.img = cardData.image + "Noir"
        this.imgCorrect = cardData.image
        this.zoneId = cardData.zoneId;
        this.typeId = cardData.typeId;
        this.correct = cardData.correct
        this.incorrect = cardData.incorrect
        this.titre = cardData.titre
        this.index = cardData.index
        this.cardData = cardData

        this.setAngle(cardData.angle)
        
        this.scaleOver = 1.2
        this.scaleOut = 1

        this.deck = deck

        this.cardImage = this.scene.add.image(0, 0, this.img).setOrigin(0.5);
        this.add(this.cardImage);

        this.rect = this.scene.add.rectangle(0, 0, this.cardImage.width, this.cardImage.height, Colors.Elmt.Blue, 0).setOrigin(0.5);
        // this.rect.setStrokeStyle(8, Colors.Elmt.Orange, 1);
        this.add(this.rect);

        this.setSize(this.cardImage.width, this.cardImage.height);
        this.setInteractive({ useHandCursor: true });
        this.scene.input.setDraggable(this)
    }

    drop(pointer, gameObject, dropZone) {
        if(dropZone.typeId !== gameObject.typeId) {
            gameObject.resetPosition()
            dropZone.setActive()
            return
        }

        gameObject.x += gameObject.parentContainer.x
        gameObject.y += gameObject.parentContainer.y
        gameObject.parentContainer.remove(gameObject)
        let moveX = gameObject.cardData.zoneX 
        let moveY = gameObject.cardData.zoneY
        if (gameObject.zoneId === dropZone.zoneId) {
            this.rect.setStrokeStyle(8, Colors.Elmt.Green, 1);
            this.deck.setDeckTrue(this.correct)
        } else {
            this.deck.setDeckFalse(this.incorrect)
            this.rect.setStrokeStyle(8, Colors.Elmt.Red, 1);
        }
        
        gameObject.disableInteractive()

        this.scene.tweens.add({
            delay: 100,
            targets: gameObject,
            duration: 300,
            x: moveX,
            y: moveY,
            scale: 0.8,
            angle: 0,
            onComplete: () => {
                gameObject.disableInteractive()
                this.setAlpha(1)
                this.setScale(1)
                this.cardImage.setTexture(this.imgCorrect)
                this.rect.setAlpha(0)
                dropZone.dropZone.setTint(0xFFFFFF);
            }
        })
    }

    dragEnd(pointer, gameObject, dropped) {
        if (!dropped) {
            gameObject.resetPosition()
        }
    }


    onDrag() {
        
    }

    setDone() {
        this.isDone = true
    }

    resetPosition(duration) {
        if (duration == undefined) {
            duration = 300
        }


        this.scene.tweens.add({
            targets: this,
            duration: duration,
            x: this.initPosition.x,
            y: this.initPosition.y,
            scale: 1,
            onComplete: () => {
                this.setInteractive({ useHandCursor: true })
            }
        })
    }
}